import {
  resourceReducer,
} from 'redux-resource';
import {
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
} from './plugins';

export default resourceReducer('personalProperties', {
  plugins: [
    includedResources,
    allListPlugin,
  ],
});
